export function matchIsNumeric(value: unknown) {
    const isNumber = typeof value === 'number';
    const isValidString = typeof value === 'string' && value.trim() !== '';
    return isNumber || (isValidString && !isNaN(Number(value)));
}

export function getWordWithNumber(value: number, words: [string, string, string]) {
    // words[0] - единственное число (1, 21, 31, ...)
    // words[1] - множественное число 2-4 (2-4, 22-24, ...)
    // words[2] - родительный падеж 5+ и 11-19 (5-20, 25-30, ...)
    const currentValue = Math.abs(value) % 100;
    const num = currentValue % 10;

    // Для чисел 11-19 всегда родительный падеж (words[2])
    if (currentValue > 10 && currentValue < 20) {
        return `${value} ${words[2]}`;
    }

    let index = 2; // По умолчанию родительный падеж
    if (num === 1) {
        index = 0; // Единственное число
    } else if (num > 1 && num < 5) {
        index = 1; // Множественное число 2-4
    }

    return `${value} ${words[index]}`;
}
